import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import AdviceSection from '../common/AdviceSection';
import SelectFilters from '../common/select-filters/SelectFilters';
import Cards from '../common/cards/Cards';
import Pagination from '../common/pagination/Pagination';
import Methodology from '../common/Methodology';

import { getOrganisations, getOSHData } from '../../api';

const Programmes = props => {

	const [organisations, setOrganisations] = useState([]);
	const [pageOfItems, setPageOfItems] = useState([]);
	const [matrixPageData, setMatrixPageData] = useState([]);
	const [isFetching, setIsFetching] = useState(false);
	const [filters, setFilters] = useState({
		organisations: [],
		checks: [],
		searchBar: ''
	})

	useEffect(() => {
		// Update the title for the page
		document.title = "Programmes" +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		setIsFetching(true);
        try {
			getOrganisations()
			.then((res) => {
				if (res) {
					setOrganisations(res.resultset);
					const selectedOrganisation = res.resultset.find((org) => org.urlName == props.organisation);
					if (selectedOrganisation != null)
					{
						setFilters( {...filters, organisations: [selectedOrganisation] } );
					}
				}
			})
			getOSHData('INTERNATIONAL_PROGRAMMES', filters)
				.then((res) => {
					// Filter the returned elements so there are no elements with empty values for all the texts
					setMatrixPageData(res.resultset.filter(item => props.literals['L'+item.text1] != "" || props.literals['L'+item.text2] != "" || props.literals['L'+item.text3] != "") );
			});
		} catch(error) {
			console.log('Error getting data: ', error)
		} finally {
			setIsFetching(false);
		}
	}, [])

	useEffect(() => {
		setIsFetching(true);
		try {
			getOSHData('INTERNATIONAL_PROGRAMMES', filters)
			.then((res) => {
				// Filter the returned elements so there are no elements with empty values for all the texts
				setMatrixPageData(res.resultset.filter(item => props.literals['L'+item.text1] != "" || props.literals['L'+item.text2] != "" || props.literals['L'+item.text3] != ""));
			})
		} catch (error) {
			console.log('Error fetching data', error)
		} finally {
			setIsFetching(false);
		}
	}, [filters])

    const handleCallbackOrganisation = (organisationCallback) => {
		const organisationFilter = filters.organisations;
		const organisation = filters.organisations.find((org) => org.id == organisationCallback.id);
		if (organisationCallback.id != organisation?.id)
		{
			setFilters( {...filters, organisations: [...organisationFilter, organisationCallback ] } );
		}
		else
		{
			const index = filters.organisations.findIndex((org) => org.id == organisationCallback.id);
			const newOrgFilters = filters.organisations;
			newOrgFilters.splice(index, 1);
			setFilters( {...filters, organisations: newOrgFilters } );
		}
	}

	//when country is selected
	const onSelectOrganisationTag = (orgID) => {
		return () => {
			const orgIndex = filters.organisations.findIndex((org) => org.id == orgID);
			const newArray = filters.organisations;
			newArray.splice(orgIndex, 1);
			setFilters( {...filters, organisations: newArray } );
		}
	}

    const handleCallbackRegion = (regionCallback) => {
		const checkFilter = filters.checks.find((data) => data.id == regionCallback.id);
		const checks = filters.checks;
		if (!checkFilter) {
			setFilters( {...filters, checks: [...checks, {...regionCallback, check: true } ] } );
		} else {
			const index = filters.checks.findIndex((data) => data.id == regionCallback.id);
			const newArray = filters.checks;
			newArray.splice(index, 1);
			setFilters( {...filters, checks: newArray } );
		}
	}

	const onSelectRegionTag = (regionCallback) => {
		return () => {
			const institutionIndex = filters.checks.findIndex((region) => region.id == regionCallback);
			const newArray = filters.checks;
			newArray.splice(institutionIndex, 1);
			setFilters( {...filters, checks: newArray } );
		}
	}

    const handleCallbackSearch = (searchCallback) => {
		setFilters( {...filters, searchBar: searchCallback } );
    }

	const onChangePage = (pageOfItems) => {
		setPageOfItems(pageOfItems);
	}

    return (
		<div className='programmes'>
			<AdviceSection literals={ props.literals } section={["osh-infrastructure","international-programmes"]} methodologyData={{section: 'osh-infrastructure', subsection: 'International programmes', indicator: 411}} />

			<section className="container">
				<p className="btn--wrapper text-right">
					<Link to='/osh-infrastructure/international-organisations' className="btn-default btn-main-color text-center "> { props.literals.L20523 }</Link>
				</p>
				<SelectFilters 
					selectCountries={ organisations }
					literals={ props.literals }
					onClickCountry={ handleCallbackOrganisation }
					onClickInstitution={ handleCallbackRegion }
					onSearchbarClick={ handleCallbackSearch }
					selectedFilters={ filters }
					filterCategory={ 'programmes' }
				/>

				<div className="selected--tags-wrapper">
					{ filters && (
						<div>
							{ filters.organisations.map((org) => (
								<span key={org.urlName} className="selected-tag" onClick={onSelectOrganisationTag(org.id)}>{props.literals[`L${org.name}`]}</span>
							))}
							{ filters.checks.map((region) => {
								if (region.check) {
									return <span key={region.id} className="selected-tag" onClick={onSelectRegionTag(region.id)} >{props.literals[`L${region.literal}`]}</span>
								}
							})}
						</div>
					)}
				</div>

				<div className="container">
					{/** Cards Component */}
					<div className="matrix--elements--wrapper">
						{pageOfItems.length > 0 ? (
							pageOfItems.map((data, index) => {
								const position = matrixPageData.findIndex((pageData) => pageData == data);
								const id = `${index}-${position}`
								return <Cards 
											key={ id } 
											idCard={ id }
											countryData={ data } 
											literals={ props.literals } 
											cardType={ 'programme' } 
										/>
							})
						) : (<span>{ props.literals.L20706 }</span>)}
					</div>

					{/* PAGINATION */}
					<Pagination items={ matrixPageData } onChangePage={ onChangePage } />
				</div>
			</section>

			<Methodology literals={ props.literals } section={'International programmes'} />
		</div>
	)
}

Programmes.displayName = 'Programmes';

export default connect(null, null)(Programmes);